//import React, { useEffect, useState } from "react";
//import {
//    PieChart,
//    Pie,
//    Cell,
//    Tooltip,
//    Legend,
//    ResponsiveContainer,
//} from "recharts";
//import useAxiosInstance from "../../../services/useAxiosInstance";

//const COLORS = [
//    "#B1E3FF",
//    "url(#gradient-black)",
//    "#A8C5DA",
//    "#A1E3CB",
//    "#FF7F50",
//    "#FFD700",
//    "#D398E7",
//    "#FF69B4",
//    "#CD5C5C",
//    "#4B0082",
//    "#20B2AA",
//    "#87CEEB",
//    "#FFA07A",
//    "#9370DB",
//    "#E89271",
//    "#7B68EE",
//];

//const CountryPieChart = ({ startDate, endDate }) => {
//    const axiosInstance = useAxiosInstance();

//    const [pieData, setPieData] = useState([]);

//    useEffect(() => {
//        const fetchData = async () => {
//            if (!startDate || !endDate) {
//                console.warn("Start date or end date is not defined");
//                return;
//            }

//            try {
//                const params = {
//                    startDate: startDate,
//                    endDate: endDate
//                };

//                const response = await axiosInstance.get(`/api/public/address/admin/percentages`, {
//                    params: params
//                });

//                const data = response.data.map((item) => ({
//                    name: item.statename,
//                    value: parseFloat(item.percentage.replace("%", "")),
//                }));
//                setPieData(data);
//            } catch (error) {
//                console.error("Error fetching the data", error);
//            }
//        };

//        fetchData();
//    }, [startDate, endDate]);

//    const renderLegendText = (value, entry) => {
//        const { value: percentage } = entry.payload;
//        return `${value}: ${percentage}%`;
//    };

//    return (
//        <div>
//            <div className="p-5">
//                <h3>Users by country</h3>
//            </div>
//            <div className="relative bottom-5">
//                <ResponsiveContainer width="100%" height={500}>
//                    <PieChart>
//                        <defs>
//                            <linearGradient
//                                id="gradient-black"
//                                x1="0%"
//                                y1="0%"
//                                x2="0%"
//                                y2="100%"
//                            >
//                                <stop
//                                    offset="0%"
//                                    style={{ stopColor: "#000000", stopOpacity: 1 }}
//                                />
//                                <stop
//                                    offset="60%"
//                                    style={{ stopColor: "rgba(28, 28, 28, 0.6)", stopOpacity: 1 }}
//                                />
//                                <stop
//                                    offset="100%"
//                                    style={{ stopColor: "rgba(0, 0, 0, 0.6)", stopOpacity: 1 }}
//                                />
//                            </linearGradient>
//                        </defs>
//                        <Pie
//                            data={pieData}
//                            cx="50%"
//                            cy="50%"
//                            innerRadius={60}
//                            outerRadius={120}
//                            fill="#8884d8"
//                            paddingAngle={5}
//                            dataKey="value"
//                        >
//                            {pieData.map((entry, index) => (
//                                <Cell
//                                    key={`cell-${index}`}
//                                    fill={COLORS[index % COLORS.length]}
//                                />
//                            ))}
//                        </Pie>
//                        <Tooltip formatter={(value) => `${value}%`} />
//                        <Legend formatter={renderLegendText} layout="vertical" />
//                    </PieChart>
//                </ResponsiveContainer>
//            </div>

//            {/* Add custom styles */}
//            <style jsx global>{`
//        .recharts-default-legend {
//          width: 80%;
//          display: flex;
//          flex-wrap: wrap;
//          justify-content: center;
//          align-items: center;
//          gap: 10px;
//          position: relative;
//          bottom: 40px;
//          left: 40px;
//        }

//        .recharts-legend-item {
//          display: inline-flex;
//          align-items: center;
//          margin-right: 10px;
//          font-size: 16px;
//          color: #333;
//          font-weight: 400;
//          text-align: center;
//        }

//        .recharts-legend-item .recharts-surface {
//          margin-right: 8px;
//        }

//        .recharts-legend-item-text {
//          color: #555;
//          font-weight: 500;
//        }

//        @media (max-width: 768px) {
//          .recharts-default-legend {
//            padding: 5px 10px;
//          }

//          .recharts-legend-item {
//            font-size: 12px;
//          }
//        }
//      `}</style>
//        </div>
//    );
//};

//export default CountryPieChart;

import React, { useEffect, useState } from "react";
import {
    PieChart,
    Pie,
    Cell,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from "recharts";
import useAxiosInstance from "../../../services/useAxiosInstance";
import { useSelector } from "react-redux";

const COLORS = [
    "#B1E3FF",
    "url(#gradient-black)",
    "#A8C5DA",
    "#A1E3CB",
    "#FF7F50",
    "#FFD700",
    "#D398E7",
    "#FF69B4",
    "#CD5C5C",
    "#4B0082",
    "#20B2AA",
    "#87CEEB",
    "#FFA07A",
    "#9370DB",
    "#E89271",
    "#7B68EE",
];

const CountryPieChart = ({ startDate, endDate }) => {
    const axiosInstance = useAxiosInstance();
    const [pieData, setPieData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const roleId = useSelector((state) => state.auth.roleId);
    const communityIds = useSelector((state) => state.auth.communityId);
    const clientId = useSelector((state) => state.auth.clientId);

    // Role-based API endpoint and parameters
    const getApiConfig = () => {
        let endpoint, params;

        switch (roleId) {
            case 1000: // Superadmin - Global geographic distribution
                endpoint = `/api/public/address/admin/percentages`;
                params = {
                    startDate: startDate,
                    endDate: endDate,
                    communityId: 0 // All communities
                };
                break;

            case 1001: // HOA Admin - Community geographic distribution
            case 1002: // Board Member - Community geographic distribution
                endpoint = `/api/public/address/admin/percentages`;
                params = {
                    startDate: startDate,
                    endDate: endDate,
                    communityId: communityIds
                };
                break;

            case 1004: // Sales Manager - Sales territory data
            case 1005: // Sales Person - Sales region data
                endpoint = `/api/sales/territory/distribution`; // Different endpoint for sales
                params = {
                    startDate: startDate,
                    endDate: endDate,
                    salesUserId: roleId === 1005 ? clientId : 0 // Individual vs team data
                };
                break;

            default:
                endpoint = `/api/public/address/admin/percentages`;
                params = {
                    startDate: startDate,
                    endDate: endDate,
                    communityId: communityIds
                };
        }

        return { endpoint, params };
    };

    const fetchData = async () => {
        if (!startDate || !endDate) {
            console.warn("Start date or end date is not defined");
            return;
        }

        setLoading(true);
        setError(null);

        const { endpoint, params } = getApiConfig();

        try {
            const response = await axiosInstance.get(endpoint, { params });

            // Handle different response structures for different roles
            let data;
            if (roleId === 1004 || roleId === 1005) {
                // Sales data might have different structure
                data = response.data.territories?.map((item) => ({
                    name: item.territoryName || item.regionName,
                    value: parseFloat(item.percentage?.replace("%", "") || item.salesPercentage || 0),
                })) || [];
            } else {
                // Standard community/admin data
                data = response.data.map((item) => ({
                    name: item.statename,
                    value: parseFloat(item.percentage.replace("%", "")),
                }));
            }

            setPieData(data);
        } catch (error) {
            console.error("Error fetching the data", error);

            // For sales roles, if endpoint doesn't exist, show placeholder data
            if (roleId === 1004 || roleId === 1005) {
                setPieData([
                    { name: "North Region", value: 35 },
                    { name: "South Region", value: 28 },
                    { name: "East Region", value: 22 },
                    { name: "West Region", value: 15 }
                ]);
            } else {
                setError("Failed to load geographic data");
                setPieData([]);
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [startDate, endDate, roleId, communityIds, clientId]);

    // Role-based title and description
    const getChartInfo = () => {
        switch (roleId) {
            case 1000:
                return {
                    title: "Users by Location - Global View",
                    description: "Geographic distribution across all communities"
                };
            case 1001:
            case 1002:
                return {
                    title: "Users by Location - Community View",
                    description: "Geographic distribution within your community"
                };
            case 1004:
                return {
                    title: "Sales by Territory - Team View",
                    description: "Sales performance across all territories"
                };
            case 1005:
                return {
                    title: "Sales by Territory - Personal View",
                    description: "Your sales performance by region"
                };
            default:
                return {
                    title: "Users by Location",
                    description: "Geographic distribution"
                };
        }
    };

    const renderLegendText = (value, entry) => {
        const { value: percentage } = entry.payload;
        return `${value}: ${percentage}%`;
    };

    const chartInfo = getChartInfo();

    if (loading) {
        return (
            <div className="flex items-center justify-center h-96">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
                    <p className="text-gray-500">Loading geographic data...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="flex items-center justify-center h-96">
                <div className="text-center">
                    <div className="text-red-500 mb-2">⚠️</div>
                    <p className="text-red-500">{error}</p>
                </div>
            </div>
        );
    }

    return (
        <div>
            <div className="p-5">
                <h3 className="text-lg font-semibold text-gray-700">{chartInfo.title}</h3>
                <p className="text-sm text-gray-500">{chartInfo.description}</p>
            </div>
            <div className="relative bottom-5">
                <ResponsiveContainer width="100%" height={500}>
                    <PieChart>
                        <defs>
                            <linearGradient
                                id="gradient-black"
                                x1="0%"
                                y1="0%"
                                x2="0%"
                                y2="100%"
                            >
                                <stop
                                    offset="0%"
                                    style={{ stopColor: "#000000", stopOpacity: 1 }}
                                />
                                <stop
                                    offset="60%"
                                    style={{ stopColor: "rgba(28, 28, 28, 0.6)", stopOpacity: 1 }}
                                />
                                <stop
                                    offset="100%"
                                    style={{ stopColor: "rgba(0, 0, 0, 0.6)", stopOpacity: 1 }}
                                />
                            </linearGradient>
                        </defs>
                        <Pie
                            data={pieData}
                            cx="50%"
                            cy="50%"
                            innerRadius={60}
                            outerRadius={120}
                            fill="#8884d8"
                            paddingAngle={5}
                            dataKey="value"
                        >
                            {pieData.map((entry, index) => (
                                <Cell
                                    key={`cell-${index}`}
                                    fill={COLORS[index % COLORS.length]}
                                />
                            ))}
                        </Pie>
                        <Tooltip
                            formatter={(value) => `${value}%`}
                            contentStyle={{
                                backgroundColor: '#f9fafb',
                                border: '1px solid #d1d5db',
                                borderRadius: '6px'
                            }}
                        />
                        <Legend formatter={renderLegendText} layout="vertical" />
                    </PieChart>
                </ResponsiveContainer>
            </div>

            {/* Add custom styles */}
            <style jsx global>{`
        .recharts-default-legend {
          width: 80%;
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          align-items: center;
          gap: 10px;
          position: relative;
          bottom: 40px;
          left: 40px;
        }
        
        .recharts-legend-item {
          display: inline-flex;
          align-items: center;
          margin-right: 10px;
          font-size: 16px;
          color: #333;
          font-weight: 400;
          text-align: center;
        }
        
        .recharts-legend-item .recharts-surface {
          margin-right: 8px;
        }
        
        .recharts-legend-item-text {
          color: #555;
          font-weight: 500;
        }
        
        @media (max-width: 768px) {
          .recharts-default-legend {
            padding: 5px 10px;
          }
          
          .recharts-legend-item {
            font-size: 12px;
          }
        }
      `}</style>
        </div>
    );
};

export default CountryPieChart;